<template>
  <section id="closing" class="section">
    <!-- <h1>Join Us in Transforming Healthcare</h1> -->
  </section>
</template>

<script>
export default {
  name: 'ClosingSection'
}
</script> 